<template> <!-- we can use functional component -->
  <div>
    <div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
					<h4 v-if="items&&items.length">
						Mail to Fax Addresses 1 to {{items.length}} of {{items.length}}
					</h4>
				</div>
				<div class="ibox-content">
					<!-- ngIf: :numbers:(numberList.numbers&&!numberList.numbers.length) -->
          <!-- ngIf: options.showProgress -->
					<Loading v-if="loading" />
          <table class="table footable  table-stripped footable-loaded" v-if="!loading">
						<thead>
							<tr>
								<th class="col-lg-4 ">Email<span class=""></span></th>
								<th class="col-lg-8 ">Description<span class=""></span></th>
							</tr>
						</thead>
						<tbody>
							<tr class="gradeX" v-for="user in items" v-bind:key="user.id" data-index="0" style="display: table-row;">
								<td>
									<span class="footable-toggle"></span><!-- ngIf: allow_admin -->
									<input type="checkbox" v-model="selectedItems" :value="user.id" />&nbsp;
									<router-link :to="{path:'edit/' + user.id}">{{user.source}}</router-link>
									<!-- <span>{{user.name}}</span> -->
								</td>
								<td>{{user.description}}</td>
							</tr>
							<!-- ngRepeat: number in :numbers:numberList.numbers track by number.number -->
						</tbody>
						<tfoot>
						<tr v-if="allowAdmin"><td colspan="2">
							<!-- <button class="btn btn-sm btn-success" ng-click="numberList.newNumber()">New</button> -->
							<router-link class="btn btn-sm btn-success" :to="{path:'/create/'}">Create</router-link>
							<button class="btn btn-sm btn-danger" @click="deleteItem()" :disabled="selectedItems.length == 0">Delete</button>
						</td></tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
  </div>
</template>

<script>
import {MailToFaxService} from "../../services/MailToFaxService";
import Loading from "../../components/Loading";
export default {
	data: () => ({loading: false, items: [], selectedItems: [], allowAdmin: false}),
	components: {Loading},
	created() {
		let $injector = this.$root.angularInjector;
		// let rootScope = $injector.get("$rootScope");
		this.allowAdmin = true;
		//   this.allowAdmin = rootScope.allow_admin;
		//   console.info("allowAdmin?", this.allowAdmin);
		//   rootScope.$watch('allowAdmin', (newVal, oldVal) => {
		// 	  console.info("new allowAdmin valu", newVal, oldVal)
		// 	  this.allowAdmin = newVal;
		//   })

		let CoreApiService = $injector.get("CoreApiService");
		this.SwalService = $injector.get("SwalService");

		// this.phonesService = $injector.get("PhonesApiService");
		this.mailToFaxService = new MailToFaxService(CoreApiService);
	},
	async mounted() {
		this.load();
		// console.info("vue", this.phones)
	},
	methods: {
		async load() {
			this.loading = true;
			this.items = await this.mailToFaxService.list();
			this.loading = false;
		},
		async deleteItem() {
			if (this.selectedItems.length == 0) {
				this.SwalService.popup({
					title: "Error",
					type: "warning",
					text: "You must select one or more items to delete"
				});
				return;
			}

			let promises = this.selectedItems.map(id => {
				return this.mailToFaxService.delete(id);
			});
			try {
				await Promise.all(promises);
				this.SwalService.popup({
					title: "Deleted"
				}).then(s => {
					this.selectedItems = [];
					this.load();
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: e.message || e.statusCode || e, type: "error"
				}).then(s => {
					this.load();
				});
			}

			// }
			// else {
			// 	alert("Error", result);
			// }
		}
	}
};
</script>